module.exports = __webpack_public_path__ + "static/media/intro-1280w.de292dca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Projects/Tommy/assets/intro-1280w.jpg
// module id = 197
// module chunks = 0